<script>
import emitter from '@/modules/events/emitter'
import eventKinds from '@/modules/events/eventKinds'
import { $axios } from '@/modules/http/axios'
import Swal from 'sweetalert2'
import { validateTaskCopy } from '@/modules/task/validators/taskCopyValidator'
import moment from 'moment-timezone'

export default {
  name: 'CopyTaskModal',
  data () {
    return {
      task: null,
      copyFields: ['zaladunek', 'rozladunek'],
      copyVrid: '',
      copyLoadingDateTime: '',
      copyUnloadingDateTime: ''
    }
  },
  created () {
    emitter.on(eventKinds.taskCopyModalRequested, e => {
      this.task = e.task
      this.copyLoadingDateTime = moment(e.task.zaladunek).format('YYYY-MM-DDTHH:mm')
      this.copyUnloadingDateTime = moment(e.task.rozladunek).format('YYYY-MM-DDTHH:mm')
    })
  },
  methods: {
    toggleFieldCheck (field) {
      if (this.copyFields.includes(field)) {
        const index = this.copyFields.indexOf(field)
        this.copyFields.splice(index, 1)
      } else {
        this.copyFields.push(field)
      }
    },
    async copyTask () {
      const taskCopy = {}

      taskCopy.numer_Przejazdu = this.copyVrid.trim()
      taskCopy.przewoznik = this.task.nazna_Firmy
      taskCopy.linia = this.task.trasa
      taskCopy.textColor = '#222222'
      taskCopy.backgroundColor = '#ffffff'
      taskCopy.altBackgroundColor = '#66FFFF'

      if (this.copyVrid.trim() === '') {
        await Swal.fire('Proszę podać nowy numer VRID', '', 'warning')
      }

      if (this.copyFields.includes('zaladunek')) {
        taskCopy.zaladunek = this.copyLoadingDateTime
      }

      if (this.copyFields.includes('rozladunek')) {
        taskCopy.rozladunek = this.copyUnloadingDateTime
      }

      if (this.copyFields.includes('stoppages')) {
        const postoje = []
        this.task.stoppages.map(s => {
          postoje.push({
            acronym: s.acronym,
            przyjazd: s.arrival,
            wyjazd: s.departure,
            backgroundColor: '#ffffff'
          })
        })

        taskCopy.postoje = postoje
      }

      if (this.copyFields.includes('nazwa_Firmy')) {
        taskCopy.nazwa_Firmy = this.task.nazna_Firmy
      }

      if (this.copyFields.includes('szacunkowy_Koszt')) {
        taskCopy.szacunkowy_Koszt = this.task.stawka
      }

      if (this.copyFields.includes('currency')) {
        taskCopy.waluta = this.task.waluta ?? 'EUR'
      }

      const { isValid, errorMessage } = validateTaskCopy(taskCopy, true)

      if (!isValid) {
        await Swal.fire(errorMessage, '', 'error')
      } else {
        try {
          await $axios.post('Task', taskCopy)
          emitter.emit(eventKinds.taskCopied)
          this.copyVrid = ''
          await Swal.fire('Skopiowano zlecenie', `Nowy numer przejazdu: ${taskCopy.numer_Przejazdu}`, 'success')
        } catch (e) {
          await Swal.fire('Nie udało się skopiować zlecenia', '', 'error')
        }
      }
    }
  }
}
</script>

<template>
  <div class="modal fade" id="taskCopyModal" tabindex="-1" aria-labelledby="taskCopyModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="taskCopyModalLabel">
            Kopiuj zlecenie: <span v-if="task" class="text-success fw-bold">{{ task.numer_Przejazdu }}</span>
          </h5>
          <button id="task-copy-modal-close-btn" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body" v-if="task">
          <form @submit.prevent="copyTask">
            <div class="text-center fw-bold mb-1">
              Określ nowy numer przejazdu oraz wybierz pola do skopiowania poniżej:
              <input type="text" placeholder="Numer przejazdu" class="form-control mt-1 mb-2" v-model="copyVrid" required>
              <div class="text-start">
                <label class="d-flex align-items-center justify-content-between mb-1">
                  <span>
                    <input type="checkbox" disabled checked> Data i godzina załadunku <span class="text-danger fw-bolder">*</span>
                  </span>
                  <span>
                    <input type="datetime-local" class="form-control" required v-model="copyLoadingDateTime">
                  </span>
                </label>
                <label class="d-flex align-items-center justify-content-between">
                  <span>
                    <input type="checkbox" disabled checked> Data i godzina rozładunku <span class="text-danger fw-bolder">*</span>
                  </span>
                  <span>
                    <input type="datetime-local" class="form-control" required v-model="copyUnloadingDateTime">
                  </span>
                </label>
                <label class="d-block">
                  <input type="checkbox" @change="toggleFieldCheck('stoppages')"> Adresy punktów
                </label>
                <label class="d-block">
                  <input type="checkbox" @change="toggleFieldCheck('nazwa_Firmy')"> Klient
                </label>
                <label class="d-block">
                  <input type="checkbox" @change="toggleFieldCheck('szacunkowy_Koszt')"> Stawka
                </label>
                <label class="d-block">
                  <input type="checkbox" @change="toggleFieldCheck('currency')"> Waluta
                </label>
              </div>
            </div>
            <div class="text-center mt-2">
              <button class="btn btn-primary">Zatwierdź kopię</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
